import React ,{useState}  from 'react';

import Axios from 'axios';
import './App.css';
import Recipe from './Component/Recipe'

import {v4 as uuidv4} from 'uuid'




const App = ()=>{

const [query,setQuery] = useState ("")

const [recipes,setrecipes] = useState([])

  const APP_ID = "12c0e8e3"
  const APP_KEY = "4a4ac20bc4b393f087ae243f5c4a7ecb"
      const url = `https://api.edamam.com/search?q=${query}&app_id=${APP_ID}&app_key=${APP_KEY}&from=0&to=3&calories=591-722&health=alcohol-free`
     


      const getData = async ()=>{
            const resualt = await Axios.get(url)

            console.log(resualt)
            setrecipes (resualt.data.hits)
            setQuery("")
      }

      const onsubmit = (e)=>{
          e.preventDefault();

          getData();
      }

      const onchange=(e)=>{
          setQuery(e.target.value)
      }
  return (
    <div className="App">
      <h1  >Searching Food </h1>

      <form className="search-form" onSubmit={onsubmit}   >
        <input className="type" type="text" placeholder="Search Food" autoComplete="off" onChange={onchange} value={query}   />
        <input className="btn" type="submit" value="search"   />
      </form>

      <div className="recipes">
        {recipes!==[] && recipes.map(recipe=> <Recipe key={uuidv4} recipe ={recipe} />)}
      </div>
    </div>
  )
}

export default App;